// 회사 코드 정규화 단일 진입점.
// store/api 를 import 하지 않는다(leaf 유지 — 순환 참조 방지: store → api/loginAPI → utils/demoCompany → 이 파일).
//
// client_token 의 companyCode 클레임에는 회사 코드(DEMO/EXKR/DOGO)가 들어온다.
// 백엔드는 로그인 시 access 토큰에 company.code 를, refresh 토큰에 schema_name 을 담고
// 갱신된 access 토큰은 refresh 클레임을 승계하는데, 이 DB 는 두 값이 항상 같다.
// (Company_sql.xml sign_up_company 가 code/schema_name 에 같은 값을 INSERT 하고,
//  실제 스키마명은 SQL 쪽에서 company_${schema} 로 접두를 붙여 만든다 → schema_name 은 'EXKR', 'company_EXKR' 이 아니다.)
// 따라서 갱신 전후로 클레임 값이 달라지지는 않는다.
//
// 그럼에도 접두를 벗기는 이유는 방어적 정규화다.
// demoCompany 는 예전부터 DEMO 와 COMPANY_DEMO 를 둘 다 인정해 왔는데 exkrCompany 는 코드 형태만 알고 있어
// 두 판별 유틸의 허용 범위가 비대칭이었다. 그 관용을 한 규칙으로 통일해 양쪽에 같게 적용한다.
// 스키마 접두가 붙은 값이 들어오는 경로가 생기더라도 회사 판별이 조용히 뒤집히지 않는다
// (EXKR 판별이 틀리면 메뉴 노출과 라우트 가드가 통째로 반대로 동작한다).
const COMPANY_SCHEMA_PREFIX = 'COMPANY_'

// 대소문자/공백을 정리하고 스키마 접두(company_)가 붙어 있으면 벗겨 회사 코드 형태로 맞춘다.
// 값이 없으면 빈 문자열이라 어떤 회사와도 일치하지 않는다(= 특정 회사로 오판하지 않음).
export const normalizeCompanyCode = (companyCode) => {
  const upperCasedCode = String(companyCode || '')
    .trim()
    .toUpperCase()
  return upperCasedCode.startsWith(COMPANY_SCHEMA_PREFIX)
    ? upperCasedCode.slice(COMPANY_SCHEMA_PREFIX.length)
    : upperCasedCode
}
